import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  coupons: [],
  loading: false,
  error: null,
  success: false,
};

const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    // Get all coupons
    getCouponsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getCouponsSuccess(state, action) {
      state.loading = false;
      state.coupons = action.payload;
      state.success = true;
    },
    getCouponsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Create coupon
    createCouponStart(state) {
      state.loading = true;
      state.error = null;
    },
    createCouponSuccess(state, action) {
      state.loading = false;
      state.coupons.push(action.payload);
      state.success = true;
    },
    createCouponFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update coupon
    updateCouponStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateCouponSuccess(state, action) {
      state.loading = false;
      state.coupons = state.coupons.map((coupon) =>
        coupon._id === action.payload._id ? action.payload : coupon
      );
      state.success = true;
    },
    updateCouponFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Delete coupon
    deleteCouponStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteCouponSuccess(state, action) {
      state.loading = false;
      state.coupons = state.coupons.filter(
        (coupon) => coupon._id !== action.payload
      );
      state.success = true;
    },
    deleteCouponFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Reset state
    resetCouponState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  getCouponsStart,
  getCouponsSuccess,
  getCouponsFailure,
  createCouponStart,
  createCouponSuccess,
  createCouponFailure,
  updateCouponStart,
  updateCouponSuccess,
  updateCouponFailure,
  deleteCouponStart,
  deleteCouponSuccess,
  deleteCouponFailure,
  resetCouponState,
} = couponSlice.actions;

export default couponSlice.reducer;
